var _path, _g, _g2, _path2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagonBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3452,
    height: 2284,
    viewBox: "0 0 3452 2284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3198.43 400.295C3225.96 421.043 3240.33 454.904 3236.13 489.124L3194.96 824.445C3190.76 858.664 3168.62 888.042 3136.88 901.513L2825.9 1033.52C2794.17 1046.99 2757.66 1042.51 2730.12 1021.76L2460.31 818.44C2432.78 797.692 2418.4 763.831 2422.61 729.611L2463.78 394.29C2467.98 360.071 2490.12 330.693 2521.85 317.222L2832.84 185.218C2864.57 171.747 2901.08 176.23 2928.62 196.978L3198.43 400.295Z",
    stroke: "#AADD5F",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11414_5680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3229.43 382.295C3256.96 403.043 3271.33 436.904 3267.13 471.124L3225.96 806.445C3221.76 840.664 3199.62 870.042 3167.88 883.513L2856.9 1015.52C2825.17 1028.99 2788.66 1024.51 2761.12 1003.76L2491.31 800.44C2463.78 779.692 2449.4 745.831 2453.61 711.611L2494.78 376.29C2498.98 342.071 2521.12 312.693 2552.85 299.222L2863.84 167.218C2895.57 153.747 2932.08 158.23 2959.62 178.978L3229.43 382.295Z",
    stroke: "#AADD5F",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11414_5680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.429 717.542C446.723 686.206 487.738 671.277 528.023 678.381L880.639 740.556C920.924 747.66 954.36 775.716 968.351 814.156L1090.81 1150.62C1104.8 1189.06 1097.22 1232.04 1070.93 1263.38L840.777 1537.66C814.482 1569 773.467 1583.93 733.182 1576.82L380.567 1514.65C340.281 1507.55 306.846 1479.49 292.855 1441.05L170.393 1104.59C156.402 1066.15 163.981 1023.16 190.276 991.828L420.429 717.542Z",
    stroke: "#4199D2",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450.248 715.568C476.542 684.232 517.557 669.304 557.843 676.407L913.412 739.104C953.697 746.207 987.133 774.263 1001.12 812.703L1124.61 1151.98C1138.6 1190.42 1131.02 1233.41 1104.73 1264.74L872.648 1541.33C846.353 1572.66 805.339 1587.59 765.053 1580.49L409.484 1517.79C369.198 1510.69 335.762 1482.63 321.771 1444.19L198.284 1104.91C184.293 1066.47 191.872 1023.49 218.166 992.152L450.248 715.568Z",
    stroke: "#4199D2",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2095.11 1715.38C2087.77 1692.79 2093.04 1667.99 2108.94 1650.34L2331.75 1402.88C2347.64 1385.23 2371.75 1377.39 2394.99 1382.33L2720.7 1451.56C2743.94 1456.5 2762.77 1473.47 2770.12 1496.06L2873.01 1812.74C2880.35 1835.34 2875.08 1860.14 2859.19 1877.79L2636.38 2125.24C2620.48 2142.9 2596.37 2150.73 2573.13 2145.79L2247.43 2076.56C2224.19 2071.62 2205.35 2054.66 2198.01 2032.07L2095.11 1715.38Z",
    stroke: "#BA2980",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11414_5680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2109.11 1746.38C2101.77 1723.79 2107.04 1698.99 2122.94 1681.34L2345.75 1433.88C2361.64 1416.23 2385.75 1408.39 2408.99 1413.33L2734.7 1482.56C2757.94 1487.5 2776.77 1504.47 2784.12 1527.06L2887.01 1843.74C2894.35 1866.34 2889.08 1891.14 2873.19 1908.79L2650.38 2156.24C2634.48 2173.9 2610.37 2181.73 2587.13 2176.79L2261.43 2107.56C2238.19 2102.62 2219.35 2085.66 2212.01 2063.07L2109.11 1746.38Z",
    stroke: "#BA2980",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11414_5680",
    x: 2438.78,
    y: 150.445,
    width: 837.169,
    height: 885.844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.866667 0 0 0 0 0.372549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11414_5680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11414_5680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11414_5680",
    x: 155.984,
    y: 665.139,
    width: 955.234,
    height: 922.928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.513726 0 0 0 0 0.74902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11414_5680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11414_5680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11414_5680",
    x: 2089.06,
    y: 1397.08,
    width: 812.01,
    height: 793.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729412 0 0 0 0 0.160784 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11414_5680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11414_5680",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonBackground);
export default __webpack_public_path__ + "static/media/hexagon_background.43cc3d75e86bd966ffaceca1442f74fe.svg";
export { ForwardRef as ReactComponent };